<h2 mat-dialog-title>
  {{ 'Editing ' }}
  @if (data.type === 'Shipments') {
    {{
      data.selectedItems.length > 1
        ? data.selectedItems.length + ' shipments'
        : 'shipment ' + selectedItemsAsShipments()[0].shipmentNo
    }}
  } @else {
    {{
      data.selectedItems.length > 1
        ? data.selectedItems.length + ' containers'
        : 'container ' + selectedItemsAsContainers()[0].containerNo
    }}
  }
</h2>

<mat-dialog-content class="custom-fields">
  @if (form.controls.length > 0) {
    <div class="custom-fields__bulk-update-info">
      <span class="material-symbols-outlined">info</span>
      @if (data.selectedItems.length === 1) {
        @if (data.type === 'Shipments') {
          <span>Fields are populated with the shipment's current data</span>
        } @else {
          <span>Fields are populated with the container's current data</span>
        }
      } @else {
        <span>Custom fields data cannot be shown for bulk edit mode. All previous data will be overwritten.</span>
      }
    </div>
  }

  @for (field of form.controls; track field) {
    <div class="custom-fields__item">
      <div class="custom-fields__item--label">{{ field.get('name')?.value }}</div>
      @switch (field.get('dataType')?.value) {
        @case ('Text') {
          @if (field.get('allowedValues')?.value) {
            <app-custom-field-dropdown [group]="field" [allowEmptyValue]="true" [showHint]="true">
            </app-custom-field-dropdown>
          } @else {
            @if (field.get('validators')?.value?.maxLength > 100) {
              <app-custom-field-textarea [group]="field" [showHint]="true"></app-custom-field-textarea>
            } @else {
              <app-custom-field-text [group]="field" [showHint]="true"></app-custom-field-text>
            }
          }
        }
        @case ('DateTime') {
          <app-custom-field-datepicker [group]="field" [showHint]="true"></app-custom-field-datepicker>
        }
        @case ('Number') {
          <app-custom-field-number [group]="field" [showHint]="true"></app-custom-field-number>
        }
        @default {
          <input matInput type="text" formControlName="value" />
        }
      }
    </div>
  } @empty {
    <div class="custom-fields__no-columns">
      <span class="material-symbols-outlined">info</span>
      <span
        >There are no editable fields available in this view. Please update the tab configuration to include the fields
        you want to modify.</span
      >
    </div>
  }
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-stroked-button matDialogClose>Cancel</button>
  @if (saving) {
    <button mat-flat-button disabled>Saving</button>
  } @else {
    <button mat-flat-button (click)="save()">Save</button>
  }
</mat-dialog-actions>
